import { getIconProps, IconProps } from '../utils';
import { Building2 } from 'lucide-react';

export const SavedLocationIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Building2 {...iconProps} />;
};

export const SavedLocationsScreenIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return (
    <svg
      width={iconProps.width}
      height={iconProps.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={iconProps.style}>
      <path
        d="M16 13.3744C19.5318 14.0688 22 15.6547 22 17.5C22 19.9853 17.5228 22 12 22C6.47715 22 2 19.9853 2 17.5C2 15.6547 4.46819 14.0688 8 13.3744M12 17V9M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9Z"
        stroke={iconProps.stroke}
        strokeWidth={iconProps.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
